"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Adam Drda
 * @author Tomas Leity
 */


var WindowItemSimulationSupplierDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemSimulationSupplierDTO, _DomainObject_1$Domai);

  function WindowItemSimulationSupplierDTO(preferredPromoPurchasePrice, preferredPromoPurchaseStartDate, preferredUnitBackDiscount, preferredSupplierId, preferredCurrencyId, preferredRegularPurchasePrice, preferredRegularPurchasePriceNett) {
    var _this;

    _classCallCheck(this, WindowItemSimulationSupplierDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemSimulationSupplierDTO).call(this));
    _this.preferredPromoPurchasePrice = preferredPromoPurchasePrice;
    _this.preferredPromoPurchaseStartDate = preferredPromoPurchaseStartDate;
    _this.preferredUnitBackDiscount = preferredUnitBackDiscount;
    _this.preferredSupplierId = preferredSupplierId;
    _this.preferredCurrencyId = preferredCurrencyId;
    _this.preferredRegularPurchasePrice = preferredRegularPurchasePrice;
    _this.preferredRegularPurchasePriceNett = preferredRegularPurchasePriceNett;
    return _this;
  }

  return WindowItemSimulationSupplierDTO;
}(DomainObject_1.DomainObject);

exports.WindowItemSimulationSupplierDTO = WindowItemSimulationSupplierDTO;

WindowItemSimulationSupplierDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItemSimulationSupplierDTO.name);
  return {
    preferredPromoPurchasePrice: builder.bigNum('preferredPromoPurchasePrice'),
    preferredPromoPurchaseStartDate: builder.opt(builder.date('preferredPromoPurchaseStartDate')),
    preferredUnitBackDiscount: builder.opt(builder.bigNum('preferredUnitBackDiscount')),
    preferredSupplierId: builder.str('preferredSupplierId'),
    preferredCurrencyId: builder.str('preferredCurrencyId'),
    preferredRegularPurchasePrice: builder.bigNum('preferredRegularPurchasePrice'),
    preferredRegularPurchasePriceNett: builder.bigNum('preferredRegularPurchasePriceNett')
  };
}();